export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10572.d246a06e.jpg";